import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { resultsConfigSelector } from 'ctm-selectors';
import { Text, SimpleFlexbox } from 'ctm-components';
import { SimpleRadioButtonGroup } from '../../form/simple_radio_button_group/simple_radio_button_group';

class _SidebarFrequencyToggle extends PureComponent {

    /**
   * Handles the on change method
   * @param {Event} event - the on change event
   * @param {string} value - the value to set
   */
    onChange = (event, value) => {
        const { sortResults, setFrequencyFilter } = this.props;
        sortResults(value);
        setFrequencyFilter(value);
    };

    render = () => {
        return (
            <div>
                <SimpleFlexbox padding="bottom_xsmall">
                    <Text size="large" variant="margin_top_bottom_small"><strong>Payment frequency</strong></Text>
                </SimpleFlexbox>
                <SimpleRadioButtonGroup {...this.props} onChange={this.onChange} />
            </div>
        );
    };

}

_SidebarFrequencyToggle.propTypes = {
    sortResults: PropTypes.func,
    setFrequencyFilter: PropTypes.func,
    value: PropTypes.string,
    options: PropTypes.arrayOf(
        PropTypes.shape({
            value: PropTypes.string,
            label: PropTypes.string
        })
    )
};

const mapStateToProps = (state) => {
    return {
        value: resultsConfigSelector(state).getIn(['filters', 'frequency'])
    };
};

const mapDispatchToProps = (dispatch) => ({
    sortResults: (frequency) => {
        dispatch({
            type: 'SORT_RESULTS',
            sortBy: `productMeta.price.${frequency}Premium`,
            sortDir: 'asc',
            sortType: 'numeric'
        });
    },
    setFrequencyFilter: (frequency) => {
        dispatch({
            type: 'SET_FILTER_VALUE',
            filter: 'frequency',
            filterValue: frequency
        });
    }
});

const SidebarFrequencyToggle = connect(mapStateToProps, mapDispatchToProps)(_SidebarFrequencyToggle);

export { SidebarFrequencyToggle, _SidebarFrequencyToggle };
